// extracted by mini-css-extract-plugin
module.exports = {"leftBlock":"burger-ingredients_leftBlock__1fc-E","wrapper":"burger-ingredients_wrapper__4IsT5"};